import { render, staticRenderFns } from "./common-header.vue?vue&type=template&id=98bd0148&scoped=true&"
import script from "./common-header.vue?vue&type=script&setup=true&lang=ts&"
export * from "./common-header.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./common-header.vue?vue&type=style&index=0&id=98bd0148&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bd0148",
  null
  
)

export default component.exports